<template>
  <a-config-provider :locale="currentLocale">
    <router-view></router-view>
    <PreviewMediaModal
      v-model:visible="visible"
      :mediaList="mediaList"
      :mediaIndex="mediaIndex"
      ref="preview"
    />
    <ProblemFeedback ref="problemFeedbackRef"></ProblemFeedback>
  </a-config-provider>
</template>

<script lang="tsx">
import { useI18n } from "vue-i18n";
import { computed, defineComponent, onMounted, ref, Ref } from "vue";
import { Modal } from "ant-design-vue";
import zh_CN from "ant-design-vue/es/locale/zh_CN";
import en_US from "ant-design-vue/es/locale/en_US";
import vi_VN from "ant-design-vue/es/locale/vi_VN";
import th_TH from "ant-design-vue/es/locale/th_TH";
import useGlobalEventBus from "./hooks/useGlobalEventBus";
import { useRouter } from "vue-router";
import store from "@/store";
import { debounce } from "lodash-es";
import { closeChildRoute, openChildRoute } from "@/router";
import PreviewMediaModal from "@/components/PreviewMediaModal.vue";
import ProblemFeedback from "@/components/ProblemFeedback/index.vue";
import { LOGIN_ERR_MSG, MSG_KEY } from "./constant/message";
const localeMap: Record<string, any> = {
  "zh-CN": zh_CN,
  "en-US": en_US,
  "vi-VN": vi_VN,
  "th-TH": th_TH,
};

export default defineComponent({
  name: "App",
  components: { PreviewMediaModal, ProblemFeedback },
  setup() {
    const { locale } = useI18n();

    const currentLocale = computed(() => {
      return localeMap[locale.value] || localeMap["zh-CN"];
    });

    const visible = ref(false);
    const problemFeedbackRef = ref();

    const mediaList: Ref<string[]> = ref([]);

    const mediaIndex: Ref<number> = ref(0);
    // function interceptRequests(currentWindow = window) {
    //   // fetch 拦截
    //   const originalFetch = currentWindow.fetch;
    //   currentWindow.fetch = async (...args) => {
    //     const response = await originalFetch(...args);
    //     const url: any = args[0];
    //     const method = args[1] && args[1].method ? args[1].method : "GET";
    //     if (url.indexOf(window.location.origin + "/web") >= 0) {
    //       console.log(response, args, "argsargs");
    //       // return response;
    //       //errorModal.show();
    //     }
    //     return response;
    //   };

    //   // XHR 拦截
    //   const originalXHROpen = currentWindow.XMLHttpRequest.prototype.open;
    //   const originalXHRSend = currentWindow.XMLHttpRequest.prototype.send;
    //   currentWindow.XMLHttpRequest.prototype.open = function (
    //     method: string,
    //     url: string | URL,
    //     async: boolean = true,
    //     ...rest: any
    //   ) {
    //     return originalXHROpen.call(this, method, url, async, ...rest);
    //   };
    //   currentWindow.XMLHttpRequest.prototype.send = function (...sendArgs: any) {
    //     console.log("XHR request sent:", this, this.responseURL, sendArgs);
    //     return originalXHRSend.apply(this, sendArgs);
    //   };
    // }

    onMounted(() => {
      // 标志位，确保只弹出一个登录过期弹框
      let isLoginExpiredModalVisible = false;
      const EventBus = useGlobalEventBus();
      const router = useRouter();
      //将接口的错位Key 挂载到全局方便子应用使用
      window.MSG_KEY = MSG_KEY;
      // interceptRequests();
      // 添加退出登录清理逻辑

      // window.addEventListener("unhandledrejection", function (event) {
      //   if (
      //     event.reason &&
      //     event.reason.message &&
      //     event.reason.message.includes("Failed to fetch dynamically imported module")
      //   ) {
      //     // 这里可以弹窗或自定义处理
      //     errorModal.show();
      //     // console.error("动态 import Promise 加载失败:", event);
      //   }
      // });
      EventBus.$on(
        "LOGIN_EXPIRED",
        debounce(function () {
          if (isLoginExpiredModalVisible) return; // 如果弹框已显示，则直接返回
          isLoginExpiredModalVisible = true; // 设置标志位为 true
          Modal.warning({
            title: "登录过期",
            content: "当前登录已过期，请重新登录",
            okText: "重新登录",
            closable: false,
            onOk: () => {
              // 清理全局状态
              store.commit("user/clearState");
              store.commit("tabs/clearList");
              store.commit("globalState/clearAllApps");
              // 跳转登录页
              router.replace({
                path: "/login",
                query: { redirect: router.currentRoute.value.fullPath },
              });
              isLoginExpiredModalVisible = false; // 重置标志位
            },
            onCancel: () => {
              isLoginExpiredModalVisible = false; // 重置标志位
            },
          });
        }, 200)
      );

      EventBus.$on("OPEN_DETAIL_PAGE", (route, app, isSingle) => {
        // eslint-disable-next-line no-console
        console.log(
          `%cContainer received 【${app}】 OPEN_DETAIL_PAGE 【route】:👉👉👉 `,
          "background-color: #3498DB; font-weight: bolder; color: #fff; padding: 4px",
          route
        );
        openChildRoute(route, app, false, isSingle);
      });

      EventBus.$on("CLOSE_PAGE_TAB", (pagePath, app) => {
        // eslint-disable-next-line no-console
        console.log(
          `%cContainer received 【${pagePath}】 CLOSE_PAGE_TAB :👉👉👉 `,
          "background-color: #3498DB; font-weight: bolder; color: #fff; padding: 4px",
          app
        );
        closeChildRoute(pagePath, app);
      });
      EventBus.$on("NOT_FOUND_PAGE", () => {
        // eslint-disable-next-line no-console
        router.replace({
          path: "/403",
        });
      });

      EventBus.$on("PROBLEM_FEEDBACK", () => {
        problemFeedbackRef.value.openModal();
      });
      EventBus.$on(
        "UPDATE_TAB_SUB_NAME",
        ({ fullPath, childAppPath, subName }: { fullPath: string; childAppPath: string; subName: string }) => {
          store.commit("tabs/setSubName", { fullPath, childAppPath, subName });
        }
      );

      //@ts-ignore
      window.validateLoginMsg = function (msg: string) {
        //临时方案，如果子系统报错接口msg信息是登录过期相关的则重定向到登录页面。
        if (LOGIN_ERR_MSG.includes(msg)) {
          if (isLoginExpiredModalVisible) return; // 如果弹框已显示，则直接返回
          isLoginExpiredModalVisible = true; // 设置标志位为 true
          debounce(function () {
            Modal.warning({
              title: "登录过期",
              content: "当前登录已过期，请重新登录",
              okText: "重新登录",
              closable: false,
              onOk: () => {
                isLoginExpiredModalVisible = false; // 设置标志位为 true
                // 清理全局状态
                store.commit("user/clearState");
                store.commit("tabs/clearList");
                store.commit("globalState/clearAllApps");
                // 跳转登录页
                router.replace({
                  path: "/login",
                  query: { redirect: router.currentRoute.value.fullPath },
                });
              },
              onCancel: () => {
                isLoginExpiredModalVisible = false; // 重置标志位
              },
            });
          }, 200);
        }
      };
    });

    return { currentLocale, visible, mediaList, mediaIndex, problemFeedbackRef };
  },
});
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.hidden-cancel-button {
  display: none;
}
</style>
